import React from "react";
import { Row, Col } from "react-bootstrap";

import "../../../../assets/css/my-Profile.css";
import Breadcrumbdasbord from "../../component/Breadcrumbdasbord";
import Sidebarmenu from "../../component/SidebarNavigation";

function Mycollection() {


  return (
    <section className="profile-section">
      <div className="container-fluid">
        <Row>
          {/* Left Sidebar */}
           <Sidebarmenu/>

          {/* Right Side */}
          <Col lg={10} md={9}>
 
             <Breadcrumbdasbord
                  title="My Collection"
                  items={[
                    {
                      label: "My Collection",
                    },
                  ]}
                />

            <div className="customer-wrapper">
                   <p style={{ textAlign:"center", paddingTop:"20px"}}>   No Data Avilable  </p>
              {/* Search */}
              {/* <div className="customer-header">
                <div className="search-box">
                  <Search size={18} />
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    className="border-0 shadow-none"
                  />
                </div>
              </div> */}

              {/* Table */}
              {/* <div className="table-card-box"> 
              <div className="table-responsive">
                <Table bordered hover className="customer-table mb-0">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Customer</th>
                      <th>Mobile</th>
                      <th>Email</th>
                      <th>City</th>
                      <th>State</th>
                    </tr>
                  </thead>

                  <tbody>
                    {holdorder.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.customer}</td>
                        <td>{item.mobile}</td>
                        <td>{item.email}</td>
                        <td>{item.city}</td>
                        <td>{item.state}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
              </div> */}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default Mycollection;